"use client";

import { useRouter } from "next/navigation";
import { Button } from "@heroui/react";
import { ArrowLeft } from "lucide-react";
import { useEffect, useState } from "react";

export default function BackButton() {
  const router = useRouter();
  const [canGoBack, setCanGoBack] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined") {
      // Check if the user came from the events page
      const referrer = document.referrer;
      const isFromEventsPage = referrer.includes("/events");
      const hasHistory = window.history.length > 1;

      setCanGoBack(isFromEventsPage && hasHistory);
    }
  }, []);

  const handleBack = () => {
    if (typeof window !== "undefined") {
      if (canGoBack) {
        // Use browser's back button to preserve scroll position
        router.back();
      } else {
        // Fallback to events page
        router.push("/events");
      }
    } else {
      // Fallback for SSR
      router.push("/events");
    }
  };

  return (
    <Button
      onPress={handleBack}
      variant="flat"
      size="sm"
      className="bg-canvas/30 backdrop-blur-sm text-ink"
      startContent={<ArrowLeft className="w-4 h-4" />}
    >
      {canGoBack ? "Back" : "All Events"}
    </Button>
  );
}
